<div class="main-body">
    <div class="sweet-spot-page-content">
        <div class="sweet-spot-page-manage-banner">
            <div class="container">
                <h2 *ngIf="SweetSpotId == 0 && selectedLang == 'eng'">Sweet Spot Management Module</h2>
                <p class="mt-3" *ngIf="SweetSpotId == 0 && selectedLang == 'eng'">
                    Select the specific data filter criterias to define your target market for leads, keeping in mind
                    the more criterias you select the more narrowly defined your target market will be.
                </p>
                <h2 *ngIf="SweetSpotId == 0 && selectedLang == 'spa'">Módulo de gestión del punto ideal</h2>
                <p class="mt-3" *ngIf="SweetSpotId == 0 && selectedLang == 'spa'">
                    Seleccione los criterios de filtro de datos específicos para definir su mercado objetivo de clientes potenciales, teniendo en cuenta que cuantos más criterios seleccione, más preciso será su mercado objetivo.
                </p>
                <h2 *ngIf="tabTitles[activeTab] && SweetSpotId > 0">{{ tabTitles[activeTab] }}</h2>
                <p class="mt-3" *ngIf="tabDescriptions[activeTab] && SweetSpotId > 0">
                   {{ currentDescription }}
                </p>
            </div>
        </div>
        <div class="sweet-spot-tab">
            <div class="container">

                <div class="row">
                    <div class="col-lg-6 m-auto d-table">
                        <button class="back-button mb-4 fs-5" (click)="goBack()">
                            <mat-icon>arrow_back</mat-icon>
                            <span>{{ 'BACK' | translate }}</span>
                          </button>
                        <h6>{{ 'SWEET_SPOT_NAME' | translate }}</h6>
                        <form class="login-form d-flex gap-3 align-items-center"  [formGroup]="sweetspotForm"
                            (ngSubmit)="form.form.valid && saveSweetSpot()" #form="ngForm">
                            <mat-form-field class="w-100">
                                <input matInput type="text" placeholder="{{ 'SWEET_SPOT_PLACEHOLDER' | translate }}" formControlName="SweetSpotName" appNoWhitespace
                                    required>
                            </mat-form-field>
                            <mat-error class="text-danger"
                                *ngIf="(form.submitted || sweetspotForm.get('SweetSpotName')?.touched) && sweetspotForm.controls['SweetSpotName'].errors?.['required']">
                               {{ 'SWEET_SPOT_NAME_REQUIRED' | translate }}
                            </mat-error>
                            <!-- <mat-error class="text-danger"
                                *ngIf="(form.submitted || sweetspotForm.get('SweetSpotName')?.touched) && sweetspotForm.get('SweetSpotName')?.hasError('pattern')">
                                Please enter correct sweet spot name.
                            </mat-error> -->
                            <mat-error class="text-danger"
                                *ngIf="(form.submitted || sweetspotForm.get('SweetSpotName')?.touched) && sweetspotForm.get('SweetSpotName')?.hasError('noWhitespace')">
                                {{ 'SWEET_SPOT_NAME_CORRECT_REQUIRED' | translate }}
                            </mat-error>

                            <button mat-raised-button color="primary" class="ps-4 pe-4" *ngIf="SweetSpotId == 0"
                                type="submit">{{ 'SWEET_SPOT_ADD' | translate }}</button>
                            <button mat-raised-button color="primary" *ngIf="SweetSpotId > 0"
                                type="submit" >{{ 'UPDATE' | translate }}</button>
                        </form>
                      
                    </div>
                  
                </div>

                <div class="row mt-5" *ngIf="SweetSpotId > 0">
                    <div class="col-lg-12">
                        <div class="d-flex flex-wrap flex-md-nowrap w-100">
                            <div ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-pills flex-column"
                                orientation="vertical">
                                <ng-container ngbNavItem="demographics">
                                    <button ngbNavLink (click)="goToPage('demographics')">
                                        {{ 'DEMOGRAPHICS' | translate }}
                                        <span class="icon1">{{demographicsCount}}</span></button>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </ng-container>
                                <ng-container ngbNavItem="geographic">
                                    <button ngbNavLink (click)="goToPage('geographic')">
                                        {{ 'GEOGRAPHIC' | translate }}
                                        <span class="icon1">{{geoGraphicsCount}}</span>
                                    </button>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </ng-container>
                                <!-- <ng-container ngbNavItem="house-hold-status">
                                    <button ngbNavLink (click)="goToPage('house-hold-status')">
                                        House Hold Status<span class="icon1">{{houseHoldStatusCount}}</span>
                                    </button>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </ng-container> -->
                                <ng-container ngbNavItem="house-hold-status">
                                    <button ngbNavLink (click)="goToPage('house-hold-status')" class="nav-link-with-count">
                                      <span class="label">{{ 'HOUSE_HOLD_STATUS' | translate }}</span>
                                      <span class="icon1">{{houseHoldStatusCount}}</span>
                                    </button>
                                    <ng-template ngbNavContent></ng-template>
                                  </ng-container>
                                  
                                <ng-container ngbNavItem="driving-record">
                                    <button ngbNavLink (click)="goToPage('driving-record')">
                                       {{ 'DRIVING_RECORD' | translate }}<span class="icon1">{{drivingRecordCount}}</span>
                                    </button>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </ng-container>
                                <ng-container ngbNavItem="vehicle-information">
                                    <button ngbNavLink (click)="goToPage('vehicle-information')">
                                        {{ 'VEHICLE_INFO' | translate }}<span class="icon1">{{vehicleCount}}</span>
                                    </button>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </ng-container>
                                <ng-container ngbNavItem="current-carrier-histoy">
                                    <button ngbNavLink (click)="goToPage('current-carrier-histoy')">
                                        {{ 'CURRENT_CARRIER_HISTORY' | translate }}<span class="icon1">{{currentCarrierCount}}</span>
                                    </button>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </ng-container>
                                <ng-container ngbNavItem="coverage-limit">
                                    <button ngbNavLink (click)="goToPage('coverage-limit')">
                                       {{ 'COVERAGE_LIMIT' | translate }} <span class="icon1">{{coverageount}}</span>
                                    </button>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </ng-container>
                                <ng-container ngbNavItem="sweetspot-applicability">
                                    <button ngbNavLink (click)="goToPage('sweetspot-applicability')">
                                       {{ 'SWEETSPOTS_APPLICABILITY' | translate }} <span class="icon1">{{applicabilityCount}}</span>
                                    </button>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </ng-container>
                                <ng-container ngbNavItem="customer-contact-preference">
                                    <button ngbNavLink (click)="goToPage('customer-contact-preference')">
                                       {{ 'CUSTOMER_CONTACT_PREFERNECE' | translate }}<span class="icon1">{{contactPreferenceCount}}</span>
                                    </button>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </ng-container>
                                <ng-container ngbNavItem="lead-generation-source">
                                    <button ngbNavLink (click)="goToPage('lead-generation-source')">
                                        {{ 'LEAD_GENERATION_SOURCE' | translate }}<span class="icon1">{{leadgenerationCount}}</span>
                                    </button>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </ng-container>
                            </div>
                            <div class="ms-md-5 tab-content w-100">
                                <router-outlet (activate)="subscribeToChildEmitter($event)"></router-outlet>
                            </div>
                            <!-- <div [ngbNavOutlet]="nav" class="ms-4"></div> -->
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>